var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMessages(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 35 25.59"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.945 0H1.055A1.056 1.056 0 000 1.056v2.078l17.5 11.727L35 3.133V1.056A1.056 1.056 0 0033.945 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 7.464v13.9a4.221 4.221 0 004.223 4.231h26.554A4.221 4.221 0 0035 21.368v-13.9L17.5 19.195z"
  }))));
}

export default SvgIconMessages;